.TableEmptyState {
  display: grid;
  justify-items: center;
  overflow: hidden;
  row-gap: 2em;
  text-align: center;
  white-space: pre-line;
  padding-top: 80px;

  &.hasTopPadding {
    padding-top: 110px;
  }
}
